// Both rows of the card must share one column template,
// so the Kentroller status row is aligned with the metadata row.
export const METADATA_GRID_TEMPLATE_CSS_VAR =
  '--cluster-metadata-bar-grid-template-columns';
